import { useEffect } from 'react'
import type { RefObject } from 'react'
import { motion } from '@/utils/motion'
import { useIsWide } from '@/hooks/useMediaQuery'
import { sidePanelShift } from '@/utils/sidePanel'

/**
 * Slides the passage right while the word panel is open, so the panel sits beside the
 * text instead of on top of it.
 *
 * Only on a wide screen — below that the lookup is still a popover or a bottom sheet,
 * and there is nowhere to slide to. The element is measured with its transform cleared
 * so the shift is always computed from where the passage really sits, not from wherever
 * a previous shift left it.
 */
export function useReadingShift(open: boolean, ref: RefObject<HTMLElement | null>): void {
  const isWide = useIsWide()

  useEffect(() => {
    const el = ref.current
    if (!el) return

    if (!open || !isWide) {
      void motion.shiftX(el, 0)
      return
    }

    el.style.transform = ''
    void motion.shiftX(el, sidePanelShift(el.getBoundingClientRect(), window.innerWidth))
  }, [open, isWide, ref])
}
